// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"goalsv2_scrollbar__1LsgS"};